import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { LanguageProvider } from "@/LanguageContext";
import { AuthProvider } from "@/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import Tarifs from "@/pages/Tarifs";
import Partners from "@/pages/Partners";
import ClientPortal from "@/pages/ClientPortal";
import CountryDestinations from "@/pages/CountryDestinations";
import CollectionDestinations from "@/pages/CollectionDestinations";

function SmoothScroll() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.4, smoothWheel: true, lerp: 0.09 });
    let rafId;
    function raf(time) {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    }
    rafId = requestAnimationFrame(raf);
    window.__lenis = lenis;
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return null;
}

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
          <SmoothScroll />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/tarifs" element={<Tarifs />} />
            <Route path="/partenaires" element={<Partners />} />
            <Route path="/espace-client" element={<ClientPortal />} />
            <Route path="/destinations/:slug" element={<CountryDestinations />} />
            <Route path="/collections/:slug" element={<CollectionDestinations />} />
          </Routes>
          <Toaster position="top-center" />
        </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
